import HttpService from './http.service';

import {
  getMembersSelectionfromStepforManifoldAssembly,
  getMembersSelectionfromStep,
  getMembersFromStepForStackables,
  getDivisionMembersFromStep,
  getMembersFromStepsforDynamicStackable,
  getERPCode,
  getOrderCodeComplete,
  getOrderCodeLegacy,
  getStep
} from './tactonService';

const getUniquePartIdentifierforManifold = async (startData, sessionData) => {
  let uniqueCode = uniqueCodeTemplate(startData);
  var selections = [];

  if (startData.isManifoldProduct)
    selections = getMembersSelectionfromStepforManifoldAssembly(startData);
  else selections = getMembersSelectionfromStep(startData);

  var model = {
    uniquePartIdentifier: uniqueCode,
    configModel: sessionData.configModel,
    selections: selections,
    selectionsId: '',
    divisionId: sessionData.manufacturingLocation,
    configState: startData.tactonModel.configState
  };
  let response;
  await HttpService.postByObject('bom/CreateUniquePartIdentifier', model)
    .then(res => {
      response = res.data;
    })
    .catch(error => {
      console.log(error);
    });

  return response;
};

const getConfigStateByPart = async uniquePartIdentifier => {
  var response;
  await HttpService.getAll(
    `bom/partID?uniquePartIdentifier=${uniquePartIdentifier}`
  )
    .then(res => {
      response = res.data;
    })
    .catch(error => {
      console.log(error);
    });
  return response;
};

const getConfigStateByPartNumber = async uniquePartIdentifier => {
  var response;
  await HttpService.getAll(
    `bom/configStateofPart?uniquePartIdentifier=${uniquePartIdentifier}`
  )
    .then(res => {
      response = res.data;
    })
    .catch(error => {
      console.log(error);
    });
  return response;
};

const uniqueCodeTemplate = startData => {
  var uniqueCode;
  var step = getStep(startData);

  if (!step) return;
  if (!step.hasOwnProperty('rootGroup')) return '';

  var partMem = step.rootGroup.members.filter(
    x => x.properties && x.properties?.info_group == 'yes'
  );
  if (partMem.length > 0) {
    uniqueCode = partMem[0].members.filter(
      x => x.properties?.ph_unique_code == 'yes' && x.properties?.hidden == 'no'
    );
  }
  if (uniqueCode != undefined && uniqueCode.length != 0)
    return uniqueCode[0].value;
  return '';
};

const create = async (
  startData,
  sessionData,
  sessionId,
  partNumber,
  uniquePartIdentifier
) => {
  try {
    let erpCode = getERPCode(startData);
    let completePartNumber = getOrderCodeComplete(startData);
    let legacyPartNumber = getOrderCodeLegacy(startData);

    var model;

    if (!startData.isNormalProduct) {
      var selectionData = await getMembersFromStepForStackables(
        startData,
        sessionData
      );
      model = {
        bomPayload: null,
        language: sessionData.language,
        userId: '', //cookie?
        configCodeComplete: startData?.infoGroup?.orderCodeComplete?.value,
        guid: null,
        countryCode: sessionData.countryCode,
        countryId: sessionData.countryId,
        configModel: sessionData.configModel,
        manufacturingDivision: sessionData.manufacturingDivision,
        configCodeLegacy: startData?.infoGroup?.orderCodeLegacy?.value,
        configInput: selectionData[0],
        selections: selectionData[1],
        configPayload: JSON.stringify(startData?.tactonModel),
        productId: sessionData.productId,
        ERP_Code: erpCode,
        sessionId: sessionId,
        manufacturingLocation: sessionData.manufacturingLocation
      };
    } else if (startData.isDynamicStackableProduct) {
      model = {
        bomPayload: null,
        language: sessionData.language,
        userId: '', //cookie?
        configCodeComplete:
          completePartNumber == 'order_code_complete' ? '' : completePartNumber,
        guid: null,
        countryCode: sessionData.countryCode,
        countryId: sessionData.countryId,
        configModel: sessionData.configModel,
        manufacturingDivision: sessionData.manufacturingDivision,
        configCodeLegacy: legacyPartNumber,
        configInput: getMembersFromStepsforDynamicStackable(
          startData.tactonModel.steps.filter(
            x => x.available && !x.name.includes('initial_step')
          )
        ),
        selections: getDivisionMembersFromStep(startData),
        configPayload: JSON.stringify(startData?.tactonModel),
        productId: sessionData.productId,
        ERP_Code: erpCode,
        sessionId: sessionId,
        manufacturingLocation: sessionData.manufacturingLocation
      };
    } else if (startData.isManifoldProduct) {
      model = {
        bomPayload: null,
        language: sessionData.language,
        userId: '', //cookie?
        configCodeComplete: partNumber,
        guid: null,
        countryCode: sessionData.countryCode,
        countryId: sessionData.countryId,
        configModel: sessionData.configModel,
        manufacturingDivision: sessionData.manufacturingDivision,
        configCodeLegacy: partNumber,
        configInput: null,
        selections: getMembersSelectionfromStepforManifoldAssembly(startData),
        configPayload: null,
        productId: sessionData.productId,
        ERP_Code: partNumber,
        sessionId: sessionId,
        manufacturingLocation: sessionData.manufacturingLocation
      };
    } else {
      if (uniquePartIdentifier) {
        model = {
          bomPayload: null,
          language: sessionData.language,
          userId: '', //cookie?
          configCodeComplete: uniquePartIdentifier,
          guid: null,
          countryCode: sessionData.countryCode,
          countryId: sessionData.countryId,
          configModel: sessionData.configModel,
          manufacturingDivision: sessionData.manufacturingDivision,
          configCodeLegacy: uniquePartIdentifier,
          configInput: null,
          selections: getMembersSelectionfromStep(startData),
          configPayload: null,
          productId: sessionData.productId,
          ERP_Code: uniquePartIdentifier,
          sessionId: sessionId,
          manufacturingLocation: sessionData.manufacturingLocation
        };
      } else {
        model = {
          bomPayload: null,
          language: sessionData.language,
          userId: '', //cookie?
          configCodeComplete:
            completePartNumber == 'order_code_complete'
              ? ''
              : completePartNumber,
          guid: null,
          countryCode: sessionData.countryCode,
          countryId: sessionData.countryId,
          configModel: sessionData.configModel,
          manufacturingDivision: sessionData.manufacturingDivision,
          configCodeLegacy: getOrderCodeLegacy(startData),
          configInput: startData?.uiGroup?.members,
          selections: getDivisionMembersFromStep(startData),
          configPayload: JSON.stringify(startData.tactonModel),
          productId: sessionData.productId,
          ERP_Code: erpCode,
          sessionId: sessionId,
          manufacturingLocation: sessionData.manufacturingLocation
        };
      }
    }

    let response;
    await HttpService.postByObject('/Bom', model)
      .then(res => {
        response = res.data;
      })
      .catch(error => {
        console.log(error);
      });

    return response;
  } catch {
    return null;
  }
};

const getByPart = async partNumber => {
  var response;
  await HttpService.getAll(`Bom/part?partNumber=${partNumber}`)
    .then(res => {
      response = res.data;
    })
    .catch(error => {
      console.log(error);
    });
  return response;
};

const find = async (partNumber, configModel) => {
  var response = await HttpService.getAll(
    `bom/Find?partNumber=${partNumber}&configModel=${configModel}`
  );

  return response.data;
};

export {
  getUniquePartIdentifierforManifold,
  getConfigStateByPart,
  getConfigStateByPartNumber,
  create,
  uniqueCodeTemplate,
  getByPart,
  find
};
